import React, { JSX } from "react";
import { ServicingProviderDetail } from "@app/projects/results/servicing-provider";
import { ColumnConfig, Waffles, wafflesKeyColumnName } from "@app/shared/waffles";
import { WafflesThemes } from "@app/shared/waffles/exports";

interface MotiveScoresProps {
    record: ServicingProviderDetail;
  }

interface MotiveScoresWaffleToppings{
    [wafflesKeyColumnName]: string;
    domain: string;
    score: number;
}

const getColumnConfig = (): ColumnConfig => {
    return ({
      domain: {
        displayText: "Domain",
        noResize: true,
        noSort: true,
        testId: "motive-domain",
      },
      score: {
        displayText: "Tier",
        noResize: true, 
        noSort: true,
        testId: 'motive-score',
      },
    });
  };

const MotiveScores = (props: MotiveScoresProps): JSX.Element => {
    const getData = (): MotiveScoresWaffleToppings[] => {
        if (!props.record) {
          return [];
        }
        return props.record.motiveScoresDisplay.map((score, index) => {
            /* eslint-disable sort-keys */
            return {
              [wafflesKeyColumnName]: index.toString(),
              domain: score?.domainDescription,
              score: score?.starValue,
            };
            /* eslint-enable sort-keys */
          });
      }
    return (<React.Fragment>
        <div className="row">
          <div className={`data-box ${props.record?.motiveScoresDisplay?.length > 0 ? 'col-sm-6 col-lg-3' : 'col-12'} align-top`}>
            <Waffles<MotiveScoresWaffleToppings>
              columns={getColumnConfig()}
              data={getData() || []}
              fullWidth={true}
              testId={`servicing-provider-profile__motive-score`}
              theme={WafflesThemes.Flyout}
            />
          </div>
      </div>
    </React.Fragment>);
}

export default MotiveScores;